//LOGIN
export const LOGIN = "/api/v1/auth/admins";

//product
export const GET_PRODUCT = "/api/v1/products/search";
export const GET_PRODUCT_BY_ID = "/api/v1/products/findById";
export const ADD_NEW_PRODUCT = "/api/v1/products/create";
export const DELETE_PRODUCT = "/api/v1/products/delete";
export const UPDATE_PRODUCT = "/api/v1/products/update";

//Category
export const GET_CATEGORY_LIST = "/api/v1/categories/findAll?page=0&size=500";
export const SEARCH_CATEGORY_LIST = "/api/v1/categories/search";
export const ADD_CATEGORY_LIST = "/api/v1/categories/create";
export const UPDATE_CATEGORY_LIST = "/api/v1/categories/update";
export const DELETE_CATEGORY_LIST = "/api/v1/categories/deleteById";

//Brand
export const GET_BRAND_LIST = "/api/v1/brands/findAll?page=0&size=500";
export const SEARCH_BRAND_LIST = "/api/v1/brands/search";
export const ADD_BRAND_LIST = "/api/v1/brands/create";
export const UPDATE_BRAND_LIST = "/api/v1/brands/update";
export const DELETE_BRAND_LIST = "/api/v1/brands/deleteById";

//Attribute
export const GET_ATTRIBUTE_LIST = "/api/v1/attributes/findAll?page=0&size=500";
export const GET_ATTRIBUTE_SEARCH = "/api/v1/attributes/search";
export const ADD_ATTRIBUTE_LIST = "/api/v1/attributes/create";
export const UPDATE_ATTRIBUTE_LIST = "/api/v1/attributes/update";
export const DELETE_ATTRIBUTE_LIST = "/api/v1/attributes/deleteById";

//Discount
export const GET_DISCOUNT_LIST = "/api/v1/discounts/findAll?page=0&size=500";
export const SEARCH_DISCOUNT_LIST = "/api/v1/discounts/search";
export const ADD_DISCOUNT_LIST = "/api/v1/discounts/create";
export const UPDATE_DISCOUNT_LIST = "/api/v1/discounts/update";
export const DELETE_DISCOUNT_LIST = "/api/v1/discounts/deleteById";

//Color
export const GET_COLORS_LIST = "/api/v1/colors/findAll?page=0&size=500";
export const SEARCH_COLORS_LIST = "/api/v1/colors/search";
export const ADD_COLORS_LIST = "/api/v1/colors/create";
export const UPDATE_COLORS_LIST = "/api/v1/colors/update";
export const DELETE_COLORS_LIST = "/api/v1/colors/deleteById";

//Model
export const GET_MODEL_LIST = "/api/v1/models/findAll";
export const SEARCH_MODEL_LIST = "/api/v1/models/search";
export const ADD_MODEL_LIST = "/api/v1/models/create";
export const UPDATE_MODEL_LIST = "/api/v1/models/update";
export const DELETE_MODEL_LIST = "/api/v1/models/deleteById";
// Pages

// News
export const GET_NEWS_LIST = "/api/v1/news/search";
export const ADD_NEWS_LIST = "/api/v1/news/create";
export const UPDATE_NEWS_LIST = "/api/v1/news/update";
export const DELETE_NEWS_LIST = "/api/v1/news/deleteById";
export const GET_NEWS_BY_ID = "/api/v1/news/findById";

//SubMenu
export const GET_SUB_MENU = "/api/v1/submenus/findAll";
export const SEARCH_SUB_MENU = "/api/v1/submenus/search";
export const CREATE_SUB_MENU = "/api/v1/submenus/create";
export const UPDATE_SUB_MENU = "/api/v1/submenus/update";
export const DELETE_SUB_MENU = "/api/v1/submenus/deleteById";

// Block
export const GET_BLOCK_LIST = "/api/v1/pages/search";
export const ADD_BLOCK_LIST = "/api/v1/pages/create";
export const UPDATE_BLOCK_LIST = "/api/v1/pages/update";
export const DELETE_BLOCK_LIST = "/api/v1/pages/delete";
export const GET_BLOCK_BY_ID = "/api/v1/pages/findById";

//Home layout
export const GET_HOME_LAYOUT = "/api/v1/collections/findAll";
export const SEARCH_HOME_LAYOUT = "/api/v1/collections/search";
export const CREATE_HOME_LAYOUT = "/api/v1/collections/create";
export const UPDATE_HOME_LAYOUT = "/api/v1/collections/update";
export const DELETE_HOME_LAYOUT = "/api/v1/collections/delete";

//BANNER
export const GET_BANNER_LIST = "/api/v1/banners/search";
export const ADD_BANNER = "/api/v1/banners/create";
export const UPDATE_BANNER = "/api/v1/banners/update";
export const DELETE_BANNER = "/api/v1/banners/deleteById";

//Badge
export const GET_BADGE = "/api/v1/badges/findAll";
export const SEARCH_BADGE = "/api/v1/badges/search";
export const CREATE_BADGE = "/api/v1/badges/create";
export const UPDATE_BADGE = "/api/v1/badges/update";
export const DELETE_BADGE = "/api/v1/badges/delete";
